
























import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component({
  name: "LogoutConfirmation",
})
export default class LogoutConfirmation extends Vue {
  @Prop({ type: Boolean, default: false }) private readonly open!: boolean;

  @Emit("update:open")
  private emitClose(): false {
    return false;
  }

  @Emit("onconfirm")
  private emitConfirm(): void {
    return;
  }

  private confirm(): void {
    this.emitConfirm();
    this.emitClose();
  }

  private close(): void {
    this.emitClose();
  }
}
